import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

/**
 * Validator that checks a slug control value is not reserved and not already in use.
 * Accepts a getter function for existing slugs so validation stays current as the list changes.
 *
 * @param getExistingSlugs A function that returns the current list of slugs already in use.
 * @param reservedSlugs Slugs that are always forbidden. Defaults to an empty list.
 * @returns ValidatorFn that returns `{ slugNotUnique: true }` on conflict, otherwise null.
 */
export const uniqueSlugValidator = (getExistingSlugs: () => string[], reservedSlugs: string[] = []): ValidatorFn => {
  return (control: AbstractControl<string>): ValidationErrors | null => {
    const slug = control.value;

    if (reservedSlugs.includes(slug) || getExistingSlugs().includes(slug)) {
      return { slugNotUnique: true };
    }

    return null;
  };
};
